<template>
    <div class="grid p-fluid">
      <!-- {{groupdata}} -->
      <div class="col-12 md:col-12"><Breadcrumb :home="breadcrumbHome" :model="breadcrumbItems" /></div>
      <div class="col-12 md:col-4">
        <div class="card card-w-title" style="height: 800px">
          <div style="col-12 md;text-align:center">
            <img v-if="groupdata.profile_image"
              :src="groupdata.profile_image"
              style="width: 200px;height:200px; border-radius: 20%"
            />
            <img v-else
              src="https://media.istockphoto.com/vectors/no-image-available-icon-vector-id1216251206?k=6&m=1216251206&s=612x612&w=0&h=G8kmMKxZlh7WyeYtlIHJDxP5XRGm9ZXyLprtVJKxd-o="
              style="width: 200px; border-radius: 20%"
            />
            <hr />
          </div>
          <div style="">
            <div class="grid">
              <!-- <div class="row"> -->
              <div class="col-4 md:col-4"><b>Name</b> </div>
              <div class="col-8 md:col-8">{{groupdata.name}}</div>
              <div class="col-4 md:col-4"><b>Route Type</b></div>
              <div class="col-8 md:col-8">{{groupdata.group_type}}</div>
              <div class="col-4 md:col-4"><b>City</b></div>
              <div class="col-8 md:col-8">{{groupdata.city}}</div>
               <div class="col-4 md:col-4"><b>State</b></div>
              <div class="col-8 md:col-8">{{groupdata.state}}</div>
             
              <div class="col-4 md:col-4"><b>Pincode</b></div>
              <div class="col-8 md:col-8">{{groupdata.pincode}}</div>
              <div class="col-4 md:col-4"><b>Address</b></div>
              <div class="col-8 md:col-8" v-if="groupdata.Address">{{groupdata.Address}} {{groupdata.city}} {{groupdata.state}} {{groupdata.pincode}}</div>
              <div class="col-8 md:col-8" v-else></div>
  
              <!-- </div> -->
            </div>
            <!-- <div class="row"><div style="col-4 md;"><b>Name :</b></div>
                          <div style="col-8 md;">Prathamesh Tamboli</div></div>
                           <div class="row"><div style="col-4 md;"><b>Name :</b></div>
                          <div style="col-8 md;">Prathamesh Tamboli</div></div> -->
          </div>
        </div>
      </div>
      <div class="col-12 md:col-8">
        <div class="card card-w-title" style="height: 800px">
      <!-- {{groupdata}} -->
            <tabs
      v-model="selectedTab"
    >
    <!-- {{tabs}} -->
      <tab
        class="tab"
        v-for="(tab, i) in tabs"
        :key="`t${i}`"
        :val="tab"
        :label="tab"
        :indicator="true"
        style="font-size: 12px;" 
        :class="{ active: i === selectedTab }">
                {{tab}}
        </tab>
    </tabs>
      <tab-panels
      v-model="selectedTab"
      :animate="true"
    >
      <tab-panel >
        <!-- {{selected_tab}} -->
        <loading
              :active="isLoadingModel"
              :can-cancel="true"
              
              color="#173EA3"
              :is-full-page="fullPage"
            ></loading>
            <!-- {{groupUserList}} -->
           
        <GroupMapUser  :groupdata="groupdata"  :group_id="group_id" :group_type="group_type" v-if="selectedTab=='User' && group_id"></GroupMapUser>
        <GroupMapVehicle   :group_id="group_id" v-if="selectedTab=='Vehicle' && group_id"></GroupMapVehicle>
        <GroupStops  :groupdata="groupdata" :group_id="group_id" v-if="selectedTab=='Stops' && group_id"></GroupStops>
        
      </tab-panel>
    </tab-panels>
  
          
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import { Tabs, Tab, TabPanels, TabPanel } from 'vue3-tabs';
  import GroupMapUser from '../components/menu/Group_Map_User'
  import GroupMapVehicle from '../components/menu/Group_Map_Vehicle'
  import GroupStops from '../components/menu/GroupStops'
  import BreadcrumbService from "../service/BreadcrumbService";

  

  import apis from "@/apis";
  
  
  export default {
    data() {
      return {
          active:"active",
          tabs : ['User','Vehicle','Stops'],
          selectedTab: "User",
          userType:"Rider",
          groupdata:[],
          group_id:'',
          group_type:"",
          groupUserList:[], 
          groupVehicleList:[], 
          isLoadingModel:false,
          BreadcrumbService : null,
          breadcrumbHome: {},
          breadcrumbItems: [],
      };
    },
    async mounted(){
      
      if(localStorage.getItem('savegroupdata'))
      {
         this.groupdata=await JSON.parse(localStorage.getItem('savegroupdata'));
         this.group_id= await this.groupdata._id;
         this.group_type= await this.groupdata.group_type;
      
      }
      await localStorage.setItem('savegroupdata','')
      
      
    },
    async created(){
      this.BreadcrumbService = new BreadcrumbService();
      let Breadcrum_data = this.BreadcrumbService.groupProfile()
      this.breadcrumbHome=Breadcrum_data.home;
      this.breadcrumbItems=Breadcrum_data.items;
    },
    methods: {

      
    
      D_M_Y_formatDate(date_parm)
      {
        if(date_parm)
        {
          let date = new Date(date_parm);
          let dd = date.getDate();
          let mm = date.getMonth() + 1;
          let yyyy = date.getFullYear();
          let new_date = dd+"-"+mm + "-" + yyyy ;
          // alert(dd)
          if(dd.toString()!="NaN")
          {
            //this.receipt_new_date = new_date;
            return new_date;
          }
          else
          {
            return date_parm;
          }
        }
      },
      toggleMenu(event) {
        this.$refs.menu.toggle(event);
      },
      onContextRightClick(event) {
        this.$refs.contextMenu.show(event);
      },
    },
    components:{
          Tabs,
      Tab,
      TabPanels,
      TabPanel,
      GroupMapVehicle,
      GroupMapUser,
      GroupStops
      
    }
  };
  </script>
  <style scoped>
  .tab.active {
  background-color: #22C55E; /* Change this to your desired color */
  color: white; /* Text color for active tab */
  border-radius: 20px;
  font-weight:bold;
}
  </style>